import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { CARS_STATE } from '../../constants';

import { GetObuDevicesByClientCodeResponseDto } from '../../types';

export const getT4EObuDevices = createReduxAsyncThunk<GetObuDevicesByClientCodeResponseDto[], string>(
  `${CARS_STATE}/getT4EObuDevicesByClientCode`,
  async (clientCode: string) => {
    return await dataSources.cars.getT4EObuDevicesByClientCode(clientCode);
  }
);
